<template>
  <div v-cloak class="Survey">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <!-- <div class="imgtitle">创作训练营</div>
        <div class="texts">赋能数智教育，拓宽创作思维，紧跟行业趋势</div> -->
      </div>
    </div>

    <!-- 中间内容 -->
    <div class="container" id="w-1200px">
      <el-tabs @tab-click="handleClick" v-model="activeName">
        <el-tab-pane
          v-for="kind in kinds"
          :key="kind.Id"
          :label="kind.Name"
          :name="kind.Id"
        ></el-tab-pane>
        <!-- 课程中心 -->

        <div
          class="survey-boxs ma-tb-10 pa-20 ma-lr-10"
          v-if="dataList.length != 0"
        >
          <div
            class="b-b-ED flex f-between ma-t-30 pa-b-20 c-pointer"
            v-for="(item, index) in dataList"
            :key="index"
            @click="toDetail(item.Id, item.AnswerId)"
          >
            <div class="">
              {{ item.Name
              }}<span class="done"
                >{{ item.AnswerId != 0 ? " | (已完成)" : "" }}
              </span>
            </div>
            <div class="">{{ item.StartTime }}</div>
          </div>
        </div>
        <div v-if="dataList.length == 0" class="width100">
          <div class="t-center ma-t-40">
            <img src="../img/empty.png" alt="" srcset="" width="200" />
            <div class="c-999">暂无数据</div>
          </div>
        </div>
      </el-tabs>
    </div>
  </div>
</template>
<style lang="scss" >
.Survey {
  .done {
    font-weight: bold;
    color: #fb004d;
  }
}

#w-1200px {
  width: 1200px;
  padding-top: 40px;
}
.ma-lr-15 {
  margin: 30px 18px 0;
}
.rz {
  width: 50%;
  margin: 15px auto;
  border-radius: 3px;
  text-align: center;
  padding: 10px 10px;
  background-color: #e6e6e6;
  color: #000;
  font-weight: 500;
}
.containerss {
  width: 1200px;

  margin: 0 auto;
  background: #ffffff;
  padding: 0px 14px 25px 14px;
  box-sizing: border-box;

  .fy {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .product-list {
      width: 370px;
      height: 121px;
      margin-right: 20px;
      margin-bottom: 38px;
      display: flex;
      justify-content: flex-start;
      .p-image {
        width: 35%;
        height: 121px;
        margin-right: 9px;
        .p-imgs {
          width: 121px;
          height: 121px;
          border-radius: 10px;
        }
      }
      .p-title {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 8px;
      }
      .p-detail {
        // width:100%;
        font-size: 14px;
        height: 38px;
        line-height: 19px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .p-right {
        width: 65%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .download {
        width: 90px;
        height: 30px;
        background: rgba(15, 117, 189, 1);
        border-radius: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}
.Survey {
  min-width: 1200px;
  background: rgba(245, 247, 250, 1);
}
.Survey .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/Survey-header.png);
  background-size: cover;
  background-position: bottom;
  position: relative;
  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;
    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }
    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.fy {
  margin-top: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Survey .container {
  width: 100%;
  // height: 600px;
  min-height: 1150px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 30px 40px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.Survey .container {
  .el-tabs__header {
    display: flex;
    justify-content: center;
  }
  .el-tabs__content {
    min-width: 1080px;
    margin: 0 auto;
  }
  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: #fb004d;
  }
  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #fb004d;
  }
  .el-tabs__content {
    margin-top: 45px;
  }
}
.Survey .student {
  width: 1100px;
  height: 106px;
  margin-bottom: 32px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  .img-left {
    width: 20%;
    height: 106px;

    .img-lefts {
      width: 187px;
      height: 106px;
    }
  }
  .text-right {
    width: 80%;
    .title {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 5px;
    }
    .text-detail {
      padding-right: 100px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .icons {
      // width: 100%;
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .deletes {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          i {
            font-size: 18px;
          }
        }
      }

      .icons-left {
        width: 100%;
        padding-right: 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-left-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
      .delete-right {
        width: 40%;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
    }
  }
}

.survey-boxs {
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
}
.survey-boxs .b-b-ED:not(:last-child) {
  border-bottom: 1px solid #ededed;
}
.ma-t-60 {
  margin-top: 60px !important;
}
.ma-t-10 {
  margin-top: 10px !important;
}
</style>
<script>
import { getSurveyCategory, getSurveyQuery } from "../api.js";
// studycollect
export default {
  name: "Survey",
  data() {
    return {
      activeName: "0",
      kinds: [{ Id: "0", Name: "全部" }],
      dataList: {},
      breadList: [{ name: "创作者调研", path: "/Survey" }],
    };
  },

  created() {
    // console.log("created----");

    getSurveyCategory().then((res) => {
      this.kinds = this.kinds.concat(res.data.Data);
      this.pageIndex = 0;
      this.getList();
    });
  },

  // 其他页面进来时更新初始数据
  activated() {
    // console.log("909090------");
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },

  methods: {
    getList() {
      let token = localStorage.getItem("AccessToken");
      let data = {
        token: token,
        source: "web",
        categoryId: this.activeName,
      };
      getSurveyQuery(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data;
        }
      });
    },
    toDetail(id = 0, AnswerId) {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/Login");
          })
          .catch(() => {
            // this.$router.go(0);
          });
        return;
      }
      if (AnswerId != 0) {
        this.$router.push({
          path: "Survey-detail-my",
          query: { answerId: AnswerId },
        });
      } else {
        this.$router.push({
          path: "/Survey-detail",
          query: { id: id },
        });
      }
    },

    //点击切换种类
    handleClick() {
      this.pageIndex = 0;
      this.getList();
    },

    upload(e) {
      window.open(e, "_blank");
    },

    // 详情
    collect(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { paths: "/Resource", name: "学习资源", id: id },
      });
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e - 1;
      this.getList();
    },
  },
};
</script>
